import React from 'react';
import { Container, Box, Typography } from '@mui/material';
import SacolaTable from '../components/sacola/SacolaTable';

const Sacola: React.FC = () => {
  return (
    <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
      <Box sx={{ mb: 3 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          Sacolas
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Gerencie as sacolas de produtos
        </Typography>
      </Box>
      <SacolaTable />
    </Container>
  );
};

export default Sacola;
